// extracted by mini-css-extract-plugin
module.exports = {"icon":"Login_icon__1O16s","buttons":"Login_buttons__17D1a"};